module.exports = __webpack_public_path__ + "img/logo.fd13e535.png";